import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError, tap, switchMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityNaturalezaJuridicaLoadRequest,
  entityNaturalezaJuridicaLoadFailure,
  entityNaturalezaJuridicaLoadSuccess,
  entityNaturalezaJuridicaAddFailure,
  entityNaturalezaJuridicaAddRequest,
  entityNaturalezaJuridicaAddSuccess,
  entityNaturalezaJuridicaChangeRequest,
  entityNaturalezaJuridicaChangeSuccess
} from './entity-naturalezas-juridica.actions';

import { Update } from '@ngrx/entity';
import { NaturalezaJuridicaService } from './naturaleza-juridica.service';
import { NaturalezaJuridica } from './naturalezas-juridica.model';

@Injectable()
export class NaturalezaJuridicaEffects {
  //load
  loadRequestNaturalezaJuridica = createEffect(() =>
    this.actions$.pipe(
      ofType(entityNaturalezaJuridicaLoadRequest),
      mergeMap(() =>
        this.naturalezaJuridicaService.getNaturalezaJuridica().pipe(
          //TODO luego cambiar a getnaturalezaJuridicaes
          map((items) => entityNaturalezaJuridicaLoadSuccess({ items })),
          catchError((error) =>
            of(entityNaturalezaJuridicaLoadFailure({ error }))
          )
        )
      )
    )
  );

  // add
  addRequestNaturalezaJuridica = createEffect(() =>
    this.actions$.pipe(
      ofType(entityNaturalezaJuridicaAddRequest),
      switchMap((action) =>
        this.naturalezaJuridicaService.addNaturalezaJuridica(action.item).pipe(
          map((item) => entityNaturalezaJuridicaAddSuccess({ item })),
          catchError((error) =>
            of(entityNaturalezaJuridicaAddFailure({ error }))
          )
        )
      )
    )
  );

  addSuccessNaturalezaJuridica = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityNaturalezaJuridicaAddSuccess),
        tap(() => this.router.navigate(['']))
      ),
    { dispatch: false }
  );

  // change
  changeRequestNaturalezaJuridica = createEffect(() =>
    this.actions$.pipe(
      ofType(entityNaturalezaJuridicaChangeRequest),
      switchMap((action) =>
        this.naturalezaJuridicaService
          .changeNaturalezaJuridica(action.item)
          .pipe(
            map((itemaux: NaturalezaJuridica) => {
              // console.log(itemaux, 'itemaux');
              const item: Update<NaturalezaJuridica> = {
                id: itemaux.id,
                changes: itemaux
              };
              return entityNaturalezaJuridicaChangeSuccess({ item });
            }),
            catchError((error) =>
              of(entityNaturalezaJuridicaAddFailure({ error }))
            )
          )
      )
    )
  );

  // delete

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private naturalezaJuridicaService: NaturalezaJuridicaService,
    private router: Router
  ) {
    this.naturalezaJuridicaService.url = environment.apiUrl;
  }
}
